import * as XLSX from 'xlsx';

export const exportWaterBalance = (waterBalance, zoneName) => {
  const summary = XLSX.utils.json_to_sheet([
    { Pokazatelj: 'DMA zona', Vrijednost: zoneName },
    { Pokazatelj: 'Period', Vrijednost: waterBalance.period },
    { Pokazatelj: 'Potrošači', Vrijednost: waterBalance.consumers },
    { Pokazatelj: 'Priključci', Vrijednost: waterBalance.serviceConnections },
    { Pokazatelj: 'Dužina mreže (km)', Vrijednost: waterBalance.distributionPipesLength },
    { Pokazatelj: 'Priključni cjevovod (km)', Vrijednost: waterBalance.connectionPipesLength },
    { Pokazatelj: 'Prosječni pritisak (bar)', Vrijednost: waterBalance.pressureBar },
    { Pokazatelj: 'NRW (%)', Vrijednost: waterBalance.nrwPercent },
    { Pokazatelj: 'ILI', Vrijednost: waterBalance.ili },
    { Pokazatelj: 'CARL (m³/god)', Vrijednost: waterBalance.carl },
    { Pokazatelj: 'UARL (m³/god)', Vrijednost: waterBalance.uarl },
  ]);
  summary['!cols'] = [{ wch: 26 }, { wch: 16 }];

  const monthly = XLSX.utils.json_to_sheet(
    (waterBalance.monthly ?? []).map((m) => ({
      Mjesec: m.month,
      'NRW (%)': m.nrwPercent,
      ILI: m.ili,
      'L/priključku/dan': m.litersPerConnectionPerDay,
      'm³/km/sat': m.m3PerKmPerHour,
    })),
  );
  monthly['!cols'] = [{ wch: 10 }, { wch: 10 }, { wch: 8 }, { wch: 18 }, { wch: 12 }];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, summary, 'Bilans');
  XLSX.utils.book_append_sheet(workbook, monthly, 'Po mjesecima');
  XLSX.writeFile(workbook, `Bilans-vode-${zoneName}-${waterBalance.period}.xlsx`);
};
